import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';

import Box from '@mui/material/Box';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { newsSelect, newsDelete } from "../../../actions/news";

import { useNavigate, useParams } from 'react-router-dom';
import { Link } from '@mui/material';

import * as common from "../../../lib";

export default function NewsView() {

  const idx  = useParams().idx;
  console.log("idx : ", idx);
  let prevPage  = useParams().prevPage;
  console.log("prevPage : ", prevPage);
  
  if (prevPage === undefined)
    prevPage = 1;

  // 리듀서 값들 저장
  const userInfo = useSelector(state => state.auth);
  console.log("userInfo : ", userInfo);

  const news_select = useSelector(state => state.news?.select?.select);
  console.log("news_select : ", news_select);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onDelete = (event) => {

      event.preventDefault();
      
      if(userInfo.isLoggedIn)
      {
        const sendDelete = {
          idx: idx,
        }
    
        console.log("sendDelete : ", sendDelete);
    
        if (window.confirm("정말 삭제하시겠습니까??") == true){    //확인
    
          // 여기서 디스패치로~
          dispatch(newsDelete(sendDelete))
          .then(data => 
          {
            console.log("newsDelete data : ", data);
    
            if (!data.success)
            {
              alert(data.msg);
              return;
            }
            else
            {
              navigate(`/dashboard/NewsList/${prevPage}`);
            }
              
          })
          .catch(e => {
            console.log(e);
          });	
        }
        else
        {   //취소
        
          return;
        
        }
      }
      else
      {
        alert("로그인 후에 삭제할 수 있습니다.");
        return;
      }
    }

    useEffect(() => {
        
        // 여기서 디스패치로~
        dispatch(newsSelect(idx))
        .then(data => 
        {
          console.log("data : ", data);
        })
        .catch(e => {
          console.log(e);
        });

        return () => {      // 언마운트
            console.log("언마운트!");
        };

    }, [dispatch])

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Box
        sx={{height:'35px',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        제목 : {news_select?.title || ""}
        </Box>
        <Box>
        내용 : {news_select?.contents || ""}
        </Box>
        <Box
        sx={{height:'35px', wordBreak: 'break-all',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        링크 : {news_select?.link || ""}
        </Box>
        <Box
        sx={{height:'35px', wordBreak: 'break-all',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        공개여부 : {news_select?.open === 0 ? "비공개" : "공개" || ""}
        </Box>
        <Box
        sx={{height:'35px',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        작성날짜 : {news_select?.reg_date || ""}
        </Box>
        <Divider />
        <Box
        sx={{ marginTop: '20px',
              whiteSpace: 'pre-line',
              overflowX: 'auto',
              wordBreak: 'break-all',
            '& > :not(style)': { m: 1 },
        }}
        >
        {news_select?.photo_file === "" ? "" : <img src={common.returnImgSrc(news_select?.photo_path, news_select?.photo_file)} width={400} /> }
        </Box>
      </CardContent>
      <CardActions>
        <Link href={`/dashboard/NewsList/${prevPage}`} underline="none">목록</Link>
        <Link href={`/dashboard/NewsModify/${idx}/${prevPage}`} underline="none">수정</Link>
        <Link onClick={(e)=>onDelete(e)} value={idx} underline="none">삭제</Link>
      </CardActions>
    </Card>
  );
}